import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
export var Content = function Content() {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 640,
    height: 427,
    viewBox: "0 0 640 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 20,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 60,
    height: 32,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 53,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 40,
    width: 99,
    height: 32,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 53,
    width: 59,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(138 44)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 92,
    width: 640,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: 640,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 148,
    width: 640,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 180,
    height: 12,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 232,
    width: 52,
    height: 20,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 239,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#091E42",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 232,
    width: 85,
    height: 20,
    rx: 3,
    fill: "#8590A2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 239,
    width: 77,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 232,
    width: 52,
    height: 20,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 239,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#091E42",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 232,
    width: 52,
    height: 20,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 239,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#091E42",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 282,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 295,
    r: 12,
    fill: "url(#pattern0_233_6340)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 279,
    width: 591,
    height: 40,
    rx: 3,
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 295,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2764,
    y: 385,
    width: 425.66,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2764,
    y: 403,
    width: 267.673,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2764,
    y: 421,
    width: 267.673,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 356,
    width: 119,
    height: 6,
    rx: 3,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 346,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 359,
    r: 12,
    fill: "url(#pattern1_233_6340)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_233_6340",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_233_6340",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_233_6340",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_233_6340",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_233_6340",
    width: 400,
    height: 400,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_233_6340",
    width: 400,
    height: 400,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
  })));
};